import React from 'react'
import { MenuSecond } from '@ow/comps'
import { useRouteTo } from '@vt/hooks'

const _MenuSecond = (props) => {
  const { menuData, children, appId, ...resolvedProps } = props
  const { transUrlIte } = useRouteTo(null, { appId })
  const menuDataByTrans = (menuData || []).map((nav) => transUrlIte(nav, appId))

  return <MenuSecond {...resolvedProps} menuData={menuDataByTrans || []} />
}
export default _MenuSecond
